import * as _ from 'lodash';
import * as moment from 'moment';
import { Company } from './Company.model';
import { NoteType } from '../../shared/enums/NoteType';
import { PaymentTerm } from '../../shared/enums/PaymentTerm';
import { Industry } from '../Industry.model';

interface projectParcel {
    _id: String;
    name: String,
    value: number,
    sapProjectId: String
};

interface productParcel {
    _id: String;
    name: String,
    value: number,
    sapItemCode: String
};

interface excellenceCenter {
    _id: String;
    name: String;
    sapCode: String;
    code: String;
    value: number;
    percentage: number;
};

interface supportCenter {
    _id: String;
    name: String;
    sapCode: String;
    code: String;
    value: number;
    percentage: number;
};

export class Parcel {
    _id: String;
    billingLetterId: string;
    number: Number;
    issueDate: Date;
    paymentDate: Date;
    created: Date;
    dueDate: Date;
    extensionDate: Date;
    issued: Boolean;
    status: Number = 0;
    value: number = 0;
    valueLiquid: number = 0;
    ordered: Boolean;
    observation: String;
    project: projectParcel[] = [];
    product: productParcel[] = [];
    excellenceCenters: excellenceCenter[] = [];
    supportCenters: supportCenter[] = [];
    industry: Industry;
    refund: any = [];
    body:String;
    competence: number = 0;
    competenceYear: number = 0;
    nf: String;
    noteType: NoteType = 0;
    iss: number = 0;
    pis: number = 0;
    irrf: number = 0;
    cofins: number = 0;
    discountGranted: number = 0;
    company: Company = null;
    cnae: String = null;
    integratedSap: Boolean = false;
    sapDocEntry: string;
    sapDocNum: string = '';
    parcelCanceled: Boolean = false;
    paymentTerm: PaymentTerm = 0;
    paymentMethod: number = 0;
    accountingLoss: number = 0;
    accountingLossJustification: string = '';
    type: number = 0;
    canEdit: Boolean = true;
    parcelJoin: string = '';
    isAnticipation: boolean = false;

    constructor(data?) {
        this.populate(data);
    }

    private populate(data) {
        data = {
            issueDate: new Date(),
            dueDate: new Date(),
            created: new Date(),
            paymentDate: new Date(),
            ...data
        };

        data.noteType = data.noteType ? parseInt(data.noteType) : 0;
        data.paymentTerm = data.paymentTerm ? parseInt(data.paymentTerm) : 0;

        if (!_.isEmpty(data))
            _.forOwn(data, (value, key) => {
                this[key] = (key == 'paymentDate' || key == 'issueDate' || key == 'dueDate') ? moment(value).add(3, 'hours') : value;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/models/billing-letter/Parcel.model.ts